import { User } from './user';
import { Company } from './company';

export class Token {

    id: number;
    value: string;
    created_at: string;
    user: User;

    constructor() {}


}
